exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/solicitacao/detalhes-solicitacao/detalhes-solicitacao.component.scss
// module id = ../../../../../src/app/components/solicitacao/detalhes-solicitacao/detalhes-solicitacao.component.scss
// module chunks = main